export const genderTranslation = (gender) => {
    if(gender === "male")
        return "Male";
    else if (gender === "female")
        return "Female";
    return "Co-Ed";
}